import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressWidthPipe } from '@shared/pipes/progress-width/progress-width.pipe';

@Component({
    selector: 'app-progress-bar',
    imports: [
        CommonModule,
        ProgressWidthPipe
    ],
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {

  @Input() totalCount!: number;
  @Input() unitCount!: number;
  @Input() challengeParticipants = false;
  @Input() textSize?: EProgressTextSize = EProgressTextSize.XS;

  size = EProgressTextSize;

}

export enum EProgressTextSize {
  XS = 'xm',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}